import React, { Component } from 'react'
import { withStyles } from '@mui/styles';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  TextField,
  Button,
  Popover,
  Typography
} from '@mui/material'


const styles = theme => ({
  root: {
    // paddingTop: 20,
    // paddingBottom: 20,
    //marginTop: theme.spacing.unit * 3,
    textAlign: "center",
    
  }
});

const textFieldStyle = {
  background: 'white',
  borderRadius: 5,
  border: 0,
  height: 39,
  width: 200,
  paddingTop: '0px',
  marginTop: 20,
  marginBottom: 0
}

class Login extends Component {
  state = {
    password: '',
    username: 'CRM_',
    resetPassDialog: false,
    last4Dialog: false,
    last4: '',
    openPopover: false,
    anchorEl: null
  }

  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value })
  }

  kcPassword = event => {
    if (event.keyCode === 13 || event.which === 13)
      this.handleLoginClick()
  }

  handleMouseDownPassword = event => {
    event.preventDefault()
  }

  handleLoginClick = () => {
    this.props.doLogin(this.state.username, this.state.password)
  }

  handleForgotClick = (e) => {
    if (this.state.username.length > 8) {
      this.setState({resetPassDialog: true})
    } else {
      this.setState({anchorEl: e.currentTarget})
      this.setState({openPopover: true})
    }
      }

  handleClose = () => {
    this.setState({resetPassDialog: false})
    this.setState({last4Dialog: false})
    this.setState({openPopover: false})
  }
  handleForgotByEmail = () => {
    this.props.forgotPass(this.state.username)
    this.setState({resetPassDialog: false})
    this.setState({last4Dialog: false})
  }
  handleSendSMS = () => {
    this.props.forgotPassSMS(this.state.username,this.state.last4)
    this.setState({resetPassDialog: false})
    this.setState({last4Dialog: false})
  }
  handleForgotBySMS = () => {
    this.setState({resetPassDialog: false})
    this.setState({last4Dialog: true})
  }



  render() {
    return (
      <div>
      <Dialog
        open
        fullScreen={false}
        maxWidth='xs'
      >
        < DialogTitle style={
          { textAlign: "center" }}>
          <img src="images/amplia_title_nobackground.png" height="40" alt="AMPLIA logo" />
        </DialogTitle>
        <DialogContent
          style={
            {
              textAlign: "center",
              marginTop: 20,
            }} >
          < DialogContentText >
            Welcome to Bmobile
          </DialogContentText>
          < DialogContentText >
            Amplia Self-Service App
          </DialogContentText>
          <TextField
            //margin="dense"
            id="name"
            placeholder="Enter CRM#"
            type="text"
            value={this.state.username}
            onChange={this.handleChange('username')}
            fullWidth
            inputProps={{ disableUnderline: true, height: 30, sx: { color: 'black', p:1 }}}
            style={textFieldStyle}
          />
          <TextField
            id="password"
            placeholder="Password"
            type="password"
            onChange={this.handleChange('password')}
            onKeyPress={this.kcPassword}
            fullWidth
            inputProps={{ disableUnderline: true, height: 30, sx: {color: 'black', p:1}}}
            style={textFieldStyle}
          />
        </DialogContent>
        <DialogActions>
          < Button onClick={this.handleLoginClick}
            style={
              {
                background: '#47ED3E',
                fontWeight: 'bold',
                borderRadius: 5,
                border: 0,
                color: '#55565A',
                height: 40,
                padding: '0 30px',
                width: 200,
                marginBottom: 0,
                marginLeft: 'auto',
                marginRight: 'auto'
              }
            } >
            SIGN IN
          </Button>
        </DialogActions>
        <DialogActions
        >
          < Button onClick={this.handleForgotClick}
            style={
              {
                color: 'rgba(71,237,62,1)',
                textTransform: 'none',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginBottom: 20,
              }
            }
          >
            Forgot Password?
          </Button>
            <Popover
                open={this.state.openPopover}
                anchorEl={this.state.anchorEl}
                onClose={this.handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}>
            <Typography >You must enter your CRM number</Typography>
          </Popover>
        </DialogActions>
        
      </Dialog>
      <Dialog   aria-labelledby="customized-dialog-title" onClose={this.handleClose} open={this.state.resetPassDialog} maxWidth='xs'style={
          { textAlign: "center",
          background: '#999999'
          }}>
            <DialogContent
          style={
            {
              textAlign: "center",
              marginTop: 20,
            }} >
          <DialogContentText >Please select how would you like to receive your temporary password</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleForgotByEmail} style={
                {
                  background: '#47ED3E',
                  fontWeight: 'bold',
                  borderRadius: 5,
                  border: 0,
                  color: '#55565A',
                  height: 40,
                  padding: '0 30px',
                  width: 200,
                  marginBottom: 0,
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }
              }>
              Email
            </Button>
            </DialogActions>
            <DialogActions>
            <Button  onClick={this.handleForgotBySMS} style={
                {
                  background: '#47ED3E',
                  fontWeight: 'bold',
                  borderRadius: 5,
                  border: 0,
                  color: '#55565A',
                  height: 40,
                  padding: '0 30px',
                  width: 200,
                  marginBottom: 0,
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }
              }>
              SMS
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog   aria-labelledby="customized-dialog-title" onClose={this.handleClose} open={this.state.last4Dialog} maxWidth='xs'
        style={
          { textAlign: "center",
          background: '#999999'
          }}>
            <DialogContent
          style={
            {
              textAlign: "center",
              marginTop: 20,
            }} >
          <DialogContentText >Plese enter last four digits of your mobile phone</DialogContentText>
          <TextField
            autoFocus
            id="last4"
            type="text"
            //color='white'
            value={this.state.last4}
            onChange={this.handleChange('last4')}
            fullWidth
            inputProps={{ disableUnderline: true, height: 30, sx: {color: 'black', p:1}}}
            style={textFieldStyle}
          />
          </DialogContent>
          <DialogActions>
            
            </DialogActions>
            <DialogActions>
            <Button  onClick={this.handleSendSMS} style={
                {
                  background: '#47ED3E',
                  fontWeight: 'bold',
                  borderRadius: 5,
                  border: 0,
                  color: '#55565A',
                  height: 40,
                  padding: '0 30px',
                  width: 200,
                  marginBottom: 0,
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }
              }>
              Send SMS
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withStyles(styles)(Login)